import { render, staticRenderFns } from "./PowerArea.vue?vue&type=template&id=7ceac2d8&scoped=true&"
import script from "./PowerArea.vue?vue&type=script&lang=js&"
export * from "./PowerArea.vue?vue&type=script&lang=js&"
import style0 from "./PowerArea.vue?vue&type=style&index=0&id=7ceac2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceac2d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ceac2d8')) {
      api.createRecord('7ceac2d8', component.options)
    } else {
      api.reload('7ceac2d8', component.options)
    }
    module.hot.accept("./PowerArea.vue?vue&type=template&id=7ceac2d8&scoped=true&", function () {
      api.rerender('7ceac2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/a-kit/forms/PowerArea.vue"
export default component.exports